import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-name',
  templateUrl: './report-name.component.html',
  styleUrls: ['./report-name.component.scss'],
})
export class ReportNameComponent implements OnInit {
  @Input() name: string;
  @Input() hasInfo: boolean = false;
  @Input() translationPrefix: string = 'reports.list.';
  @Input() translationSuffix: string = '';
  reportTranslationKey: string;
  reportInfoTranslationKey: string;
  constructor() {}

  ngOnInit() {
    this.reportTranslationKey =
      this.translationPrefix + this.name + this.translationSuffix;
    if (this.hasInfo)
      this.reportInfoTranslationKey = this.reportTranslationKey + '-info';
  }

  getEvertyhingExceptLastWord(translation: string) {
    const splittedTranslation = translation.split(' ');
    splittedTranslation.pop();
    return splittedTranslation.join(' ') + ' ';
  }

  getLastWord(translation: string) {
    return translation.split(' ').pop();
  }
}
